import { FormControl, FormControlLabel, Typography } from '@mui/material';
import { useState } from 'react';
import { TabPanel } from '@mui/lab';
import IOSSwitch from './IOSSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedFeatures, setGrantButtonDisabled, setRevokeButtonDisabled, setSelectedFeatures } from '../userSlice';

const FeaturePanel = ({ module, value, features }) => {
  const dispatch = useDispatch();
  const selectedFeatures = useSelector(selectSelectedFeatures);
  const handleChange = (event, feat) => {
    const checked = event.target.checked;
    if (checked) {
      dispatch(setSelectedFeatures({ module, featId: feat?.permission, type: 'add' }));
      dispatch(setGrantButtonDisabled(false))
    } else {
      dispatch(setSelectedFeatures({ module, featId: feat?.permission, type: 'remove' }));
      dispatch(setRevokeButtonDisabled(false))
    }
  };
  return (
    <TabPanel value={value} sx={{ flex: 0.75, ml: 1, border: 0, p: 1, pt: 0, width: 1,height:"100%" }}>
      <Typography sx={{ mb: 1 }}>Select a feature</Typography>
      <FormControl sx={{height:"97%",overflow:"scroll"}}>
        {features?.map((feat, index) => {
          return (
            <FormControlLabel
              key={index}
              control={
                <IOSSwitch sx={{ m: 1,ml:2 }} onChange={e => handleChange(e, feat?.feature)} checked={feat?.checked} />
              }
              label={feat?.feature?.description}
            />
          );
        })}
      </FormControl>
    </TabPanel>
  );
};

export default FeaturePanel;
